import * as $ from 'jquery';

export function commonShowTarget(target): any {
    if(!$(target).hasClass('active')) {
        $(target).removeClass('d-none');
        $(target).addClass('active')
    } else {
        $(target).addClass('d-none');
        $(target).removeClass('active') 
    }
}

export function buttonTextChanger(target, text) {  
    $(target).text(text);
}

export function preventClick(e) {
    e.preventDefault();
    return false;
}import * as $ from 'jquery';

export function commonShowTarget(target): any {
    if(!$(target).hasClass('active')) {
        $(target).removeClass('d-none');
        $(target).addClass('active')
    } else {
        $(target).addClass('d-none');
        $(target).removeClass('active') 
    }
}

export function buttonTextChanger(target, text) {  
    $(target).text(text);
}

export function preventClick(e) {
    e.preventDefault();
    return false;
}